import React, { useEffect, useState } from 'react';
import InputText from '../../../components/agv-forms-input';
import GenericModal from '../../../components/agv-generic-modal';
import InputRadio from '../../../components/agv-forms-radio';

export default function PackagingUpdateModal({
  isOpen,
  setIsOpen,
  updatePackaging,
  mainActionIsLoading,
  archivePackaging,
  archiveIsLoading,
  packaging,
}) {
  const [code, setCode] = useState('');
  const [label, setLabel] = useState('');
  const [isActive, setIsActive] = useState('true');
  const isEmpty = !code.trim().length || !label.trim().length;

  const isSameValues =
    code === packaging?.code &&
    label === packaging?.label &&
    (isActive === 'true') === packaging?.is_active;

  const DISABLED = isEmpty || isSameValues;

  useEffect(() => {
    if (isOpen && packaging) {
      setCode(packaging.code || '');
      setLabel(packaging.label || '');
      setIsActive(packaging.is_active ? 'true' : 'false');
    }
  }, [isOpen, packaging]);

  const handleSubmit = () => {
    const willDeactivate = packaging?.is_active && isActive === 'false';
    const hasActiveRules = (packaging?.active_rules_count ?? 0) > 0;

    if (willDeactivate && hasActiveRules) {
      const confirmed = window.confirm(
        `Ce type de palette possède ${packaging.active_rules_count} règle(s) de consigne active(s).\n` +
          'Les désactiver également ? (Cette action est requise pour désactiver la palette.)'
      );
      if (!confirmed) return;
    }

    updatePackaging(
      packaging?.id,
      code.trim(),
      label.trim(),
      isActive === 'true'
    );
  };

  const handleArchive = () => {
    const hasActiveRules = (packaging?.active_rules_count ?? 0) > 0;
    const message = hasActiveRules
      ? `Ce type de palette possède ${packaging.active_rules_count} règle(s) de consigne active(s) qui seront désactivées.\n\nArchiver ce type de palette le supprimera définitivement de la liste. Confirmer ?`
      : 'Archiver ce type de palette le supprimera définitivement de la liste. Confirmer ?';

    if (!window.confirm(message)) return;
    archivePackaging(packaging?.id);
  };

  return (
    <GenericModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={'Modifier un type de palette consignée'}
      mainAction={handleSubmit}
      mainActionText={'Modifier'}
      mainActionIsLoading={mainActionIsLoading}
      mainActionDisabled={DISABLED}
      secondaryAction={handleArchive}
      secondaryActionText={'Archiver'}
      secondaryActionVariant={'danger'}
      secondaryActionIsDisabled={archiveIsLoading || mainActionIsLoading}
      secondaryActionIsLoading={archiveIsLoading}
    >
      <div className="tw-flex tw-flex-col">
        <InputText
          value={code}
          setValue={setCode}
          fieldTitle={'Code'}
          isRequired
          emptyError={`Le champ "Code" ne peut être vide.`}
          placeholder={'Ex : PAL_NOIR'}
        />
        <InputText
          value={label}
          setValue={setLabel}
          fieldTitle={'Libellé'}
          isRequired
          emptyError={`Le champ "Libellé" ne peut être vide.`}
          style={'tw-mt-4'}
          placeholder={'Ex : Palette noire'}
        />
        <InputRadio
          value={isActive}
          setValue={setIsActive}
          fieldTitle={'Statut'}
          items={[
            { name: 'Actif', value: 'true' },
            { name: 'Inactif', value: 'false' },
          ]}
          style={'tw-mt-4'}
        />
      </div>
    </GenericModal>
  );
}
